import { useState, useCallback } from 'react';
import type { ActivityRecord } from '../types/emissions';

export const useCalculationDrawer = () => {
  const [selectedActivity, setSelectedActivity] = useState<ActivityRecord | null>(null);

  const openDrawer = useCallback((activity: ActivityRecord) => {
    setSelectedActivity(activity);
  }, []);

  const closeDrawer = useCallback(() => {
    setSelectedActivity(null);
  }, []);

  return { selectedActivity, openDrawer, closeDrawer };
};
